import { DOM, customElement, inject } from "aurelia-framework";
import { bindable } from "aurelia-typed-observable-plugin";
import Assert from "core/assert";
import { CustomEventHelper } from "helpers/custom-event-helper";
import { ExpressionObserver } from "helpers/expression-observer";
import { ServiceCallQuotationRelatedEquipmentModel } from "services/service-call-quotation-equipment-service";

@inject(Element, ExpressionObserver)
@customElement("quotation-related-equipment")
export class ServiceCallQuotationRelatedEquipmentComponent {
    @bindable public Equipment!: ServiceCallQuotationRelatedEquipmentModel;
    @bindable.booleanAttr public disabled: boolean = false;

    constructor(private readonly element: Element, private readonly expressionObserver: ExpressionObserver) {}

    public selectedChanged(newValue: boolean): void {
        CustomEventHelper.dispatchEvent(this.element, "selected-changed", newValue);
    }

    public attached(): void {
        Assert.hasValue(this.Equipment);
        this.expressionObserver.subscribeToExpression(this.Equipment, "Selected", (newValue: boolean): void => this.selectedChanged(newValue));
    }

    public detached(): void {
        this.expressionObserver.dispose();
    }
}
